import $ from 'jquery';
import slider, { alignStackedSlider } from '../slider/c-slider';

// other configs go here.
const threeSlideCustomOpts = {
    autoplay: true,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        },
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                prevArrow: '<button type="button" role="button" class="slick-prev slick-arrow"><svg class="svg-icon"><use xlink:href="#chevron-left" /></svg><span>Previous</span></button>',
                nextArrow: '<button type="button" role="button" class="slick-next slick-arrow"><span>Next</span> <svg class="svg-icon"><use xlink:href="#chevron-right" /></svg></button>'
            }
        }
    ]
};

const threeSlideTopNavCustomOpts = {
    autoplay: true,
    responsive: [
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        },
        {
            breakpoint: 1023,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3
            }
        }
    ]
};

const fourSlideCustomOpts = {
    autoplay: true,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4
            }
        }
    ]
};

const stickyNav = {
    dots: false,
    infinite: false,
    centerMode: false,
    speed: 300,
    slidesToShow: 1,
    variableWidth: true,
    swipeToSlide: true
};

$(() => {
    // default slider has no changes to the config
    if ($('.default-slider').length > 0) {
        slider('default-slider');
    }

    if ($('.three-slides').length > 0) {
        slider('three-slides:not(.dots-top)', threeSlideCustomOpts);
        slider('three-slides.dots-top', threeSlideTopNavCustomOpts);
    }

    if ($('.four-slides').length > 0) {
        slider('four-slides', fourSlideCustomOpts);
    }

    if ($('.sticky-nav-slides').length > 0) {
        slider('sticky-nav-slides', stickyNav);
    }

    alignStackedSlider();
    $(window).on('resize', () => alignStackedSlider());
});



// WEBPACK FOOTER //
// ./src/components/slider/c-slider-configs.js